<template>
  <div class='setIdentity_container'>
    <h4 class="flex_center"><img :src="images.yanHua" draggable="false" alt="">欢迎您，Key_2189，请选择你的账号身份</h4>
    <p class="p_intor">模式支持相互切换，可以在“我的-模式切换”中切换不同显示模式</p>
    <ul class="ul_identity flex_between">
      <li
        v-for="(val, index) in identityList"
        :key="index"
        class="cp_us"
        :class="activeIdentity == val.value ? 'li_active' : ''"
        @click="activeIdentity = val.value"
      >
        <div class="div_active flex_center">
          <img v-show="activeIdentity == val.value" :src="images.right" draggable="false" alt="">
        </div>
        <img :src="val.img" draggable="false" class="li_img" alt="">
        <p class="p_identity_name">{{ val.name }}</p>
        <p class="p_identity_intor">{{ val.intor }}</p>
      </li>
    </ul>
    <div class="div_bottom flex_between">
      <span class="sp_intor">选择后，如有切换需求，可以在我的模块进行模式的切换</span>
      <div class="div_btns flex">
        <!-- <el-button class="btn" @click="lookMode">查看使用模式的区别</el-button> -->
        <el-button class="btn sure_btn" @click="sureIdentity">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue';
import { ElMessage } from "element-plus";
// 方法
import { goBackToSource } from "@/utils/index";
// 接口
import { userIdentitySwitch } from "@/api/api.js";
const images = {
  yanHua: require("@/assets/images/identity/yan_hua.png"),
  right: require("@/assets/images/identity/right.svg"),
}
const identityList = [
  {
    img: require("@/assets/images/identity/student.png"),
    name: "常规模式",
    intor: "初中/高中/大学/考公等应试为目的",
    value: 1,
  },
  {
    img: require("@/assets/images/identity/teacher.png"),
    name: "老师模式",
    intor: "老师/企业培训考核管理人员",
    value: 2,
  },
]
let activeIdentity = ref(1);

// // 查看模式
// function lookMode(){

// }

// 确定身份
function sureIdentity(){
  userIdentitySwitch({
    userType: activeIdentity.value,
  }).then(res=>{
    if(res.code === 200){
      let user = JSON.parse(localStorage.getItem("userLogin"));
      localStorage.clear();
      goBackToSource(user.token);
    }else {
      ElMessage.error(res.message)
    }
  })
}
</script>

<style lang='scss' scoped>
.setIdentity_container{
  width: 856px;
  text-align: center;
  line-height: 1.4;
  margin-top: -40px;
  >h4{
    font-size: 32px;
    color: #000000;
    margin-bottom: 10px;
    img{
      height: 40px;
    }
  }
  .p_intor{
    font-size: 16px;
    color: #BCBCBC;
    margin-bottom: 40px;
  }
  .ul_identity{
    margin-bottom: 60px;
    >li{
      width: 420px;
      border-radius: 24px;
      background: #FFFFFF;
      box-shadow: 0px 20px 40px 1px rgba(0,0,0,0.05);
      border: 2px solid #EAEAEA;
      padding: 35px 25px 25px;
      box-sizing: border-box;
      position: relative;
      .div_active{
        width: 18px;
        height: 18px;
        background: #FFFFFF;
        border-radius: 5px;
        border: 2px solid #000000;
        box-sizing: border-box;
        position: absolute;
        right: 18px;
        top: 18px;
        img{
          width: 16px;
          filter: brightness(0);
        }
      }
      .li_img{
        height: 90px;
        margin-bottom: 16px;
      }
      .p_identity_name{
        font-weight: 600;
        font-size: 20px;
        color: #000000;
        margin-bottom: 3px;
      }
      .p_identity_intor{
        font-weight: 500;
        font-size: 16px;
        color: #736F7E;
      }
    }
    .li_active{
      border-color: #000000;
    }
  }
  .div_bottom{
    height: 70px;
    .sp_intor{
      font-weight: 500;
      font-size: 16px;
      color: #75767E;
      text-align: left;
      padding-right: 120px;
      box-sizing: border-box;
    }
    .div_btns{
      .btn{
        width: 210px;
        height: 70px;
        background: #FFFFFF;
        border-radius: 16px;
        border: 1px solid #DADBDD;
        box-sizing: border-box;
        font-weight: 500;
        font-size: 18px;
        color: #75767E;
      }
      .sure_btn{
        background: #222325;
        border: none;
        color: #FFFFFF;
        margin-left: 20px;
      }
    }
  }
}

// 响应式
@media (min-width: 744px) and (max-width: 1280px) {
  .setIdentity_container{
    width: 700px;
    >h4{
      font-size: 28px;
      margin-bottom: 10px;
      img{
        height: 28px;
      }
    }
    .p_intor{
      font-size: 15px;
      margin-bottom: 30px;
    }
    .ul_identity{
      margin-bottom: 50px;
      >li{
        width: 340px;
        border-radius: 20px;
        border: 2px solid #EAEAEA;
        padding: 25px 20px 20px;
        .div_active{
          width: 16px;
          height: 16px;
          border-radius: 5px;
          right: 16px;
          top: 16px;
          img{
            width: 14px;
          }
        }
        .li_img{
          height: 80px;
          margin-bottom: 14px;
        }
        .p_identity_name{
          font-size: 18px;
        }
        .p_identity_intor{
          font-size: 15px;
        }
      }
    }
    .div_bottom{
      height: 60px;
      .sp_intor{
        font-size: 15px;
        padding-right: 40px;
      }
      .div_btns{
        .btn{
          width: 180px;
          height: 60px;
          border-radius: 14px;
          font-size: 16px;
        }
        .sure_btn{
          margin-left: 20px;
        }
      }
    }
  }
}

@media (max-width: 744px) {
  .setIdentity_container{
    width: 3.5rem;
    >h4{
      font-size: 0.17rem;
      margin-bottom: .1rem;
      flex-wrap: wrap;
      img{
        height: 0.18rem;
        margin-right: 0.02rem;
      }
    }
    .p_intor{
      font-size: 0.11rem;
      margin-bottom: .3rem;
    }
    .ul_identity{
      margin-bottom: 0.2rem;
      >li{
        width: 48%;
        border-radius: 0.15rem;
        box-shadow: 0px 20px 40px 1px rgba(0,0,0,0.05);
        border: 1px solid #EAEAEA;
        padding: 0.2rem;
        font-size: 0;
        .div_active{
          width: 0.16rem;
          height: 0.16rem;
          border-radius: 5px;
          border: 1px solid #000000;
          right: 0.16rem;
          top: 0.16rem;
          img{
            width: 0.14rem;
          }
        }
        .li_img{
          height: 0.6rem;
          margin-bottom: 0.1rem;
        }
        .p_identity_name{
          font-size: 0.14rem;
          margin-bottom: 2px;
        }
        .p_identity_intor{
          font-size: 0.12rem;
        }
      }
    }
    .div_bottom{
      height: auto;
      flex-direction: column;
      align-items: flex-start;
      .sp_intor{
        font-size: 0.12rem;
        padding-right: 0;
      }
      .div_btns{
        width: 100%;
        margin-top: 0.2rem;
        justify-content: space-between;
        .btn{
          width: 1.4rem;
          height: 0.5rem;
          border-radius: 0.1rem;
          font-size: 0.12rem;
        }
        .sure_btn{
          margin-left: 0.2rem;
        }
      }
    }
  }
}
</style>